import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import { FC, PropsWithChildren } from 'react'

export const WrapperCenter: FC<PropsWithChildren> = ({ children }) => {
    return (
        <Grid
            container
            spacing={2}
            sx={{
                alignContent: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%',
            }}>
            <Grid sx={{ textAlign: 'center' }}>
                <Box sx={{ display: 'flex' }}>{children}</Box>
            </Grid>
        </Grid>
    )
}
